import { useAuth } from '@/hooks/use-auth';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/dashboard')({
  component: HomePage,
});

function HomePage() {
  const { user } = useAuth();

  return (
    <div className="space-y-6">
      <div className="rounded-lg border bg-white p-6 shadow-sm">
        <h2 className="text-2xl font-bold">Welcome Home!</h2>
        <p className="mt-2 text-gray-600">
          You're logged in as <strong>{user?.email || 'Guest'}</strong>
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2">
        <div className="rounded-lg border bg-white p-6 shadow-sm">
          <h3 className="font-semibold">Quick Stats</h3>
          <p className="mt-2 text-sm text-gray-600">Dashboard content coming soon...</p>
        </div>

        <div className="rounded-lg border bg-white p-6 shadow-sm">
          <h3 className="font-semibold">Recent Activity</h3>
          <p className="mt-2 text-sm text-gray-600">Activity feed coming soon...</p>
        </div>
      </div>
    </div>
  );
}
